class ColorUtils {
	static getContrastingColor(bgColor) {
		// Pobierz składniki RGB z koloru tła
	  	const hex = bgColor.replace('#', '');
	  	// Rozbij hex na składniki R, G, B
		const r = parseInt(hex.substring(0, 2), 16); // Pierwsze 2 znaki - czerwony
		const g = parseInt(hex.substring(2, 4), 16); // Kolejne 2 znaki - zielony
		const b = parseInt(hex.substring(4, 6), 16); // Ostatnie 2 znaki - niebieski
		const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
		return luminance > 0.5 ? '#000000' : '#ffffff'; // Czerń dla jasnych kolorów, biel dla ciemnych
  	}
}

export default ColorUtils;
